import { lazy } from "react";
import { Route } from "react-router-dom";

const CasesTable = lazy(() => import("../../containers/cases/CasesTable"));
const CaseDetails = lazy(() => import("../../containers/cases/details/Overview"));

export const local31Routes = (link: string) => [
	{
		key: "3.1.1",
		link: link + "/",
		component: (props: any) => <CasesTable {...props} />,
	},
];

export default function Key31Routes(key: string, link: string) {
	const key31Routes = [
		{ key: key, link: link + "/case/", component: (props: any) => <CaseDetails {...props} /> },
		...local31Routes(link),
	];

	return key31Routes.map((r) => <Route exact key={r.key} path={r.link} render={r.component} />);
}
